import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessHome } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { RequireFeatureFlag } from "@/components/Routing/RequireFeatureFlag";
import { routes } from "@/routes";

import { LegacyProjectHomePage } from "./pages/home-legacy/LegacyProjectHomePage";
import { ProjectHomePage } from "./pages/home/ProjectHomePage";
import { projectHomeRoutes } from "./routes";

export const projectHomeRoute = [
  {
    path: projectHomeRoutes.home,
    element: (
      <RequireAuth permission={canAccessHome} redirect={(slug) => routes.communityFeed.list({ slug })}>
        <RequireFeatureFlag flag="isDashboardV3Available" fallback={<LegacyProjectHomePage />}>
          <ProjectHomePage />
        </RequireFeatureFlag>
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
